export default {
    "MENU": {
        "DASHBOARD": "Dashboard",
        "PROFILE": "Profile",
        "PLACES": "Locations",
        "ARTISTS": "Artists",
        "PROGRAMS": "Programs",
        "USERS": "Users",
        "CONTENT": "Content",
        "MEDIA": "Media",
        "POST": "Post",
        "POSTS": "Posts",
        "CATEGORIES": "Categories",
        "POST_CATEGORIES": "Post categories",
        "WISHLISTS": "Wishlists",
        "STATISTICS": "Stats",
        "SUBSCRIBERS": "Subscribers",
        "CITIES": "Cities",
        "NEWS": "News",
        "SETTINGS": "Settings",
        "MENUS": "Menus",
        "INFO": "Travel/Accommodation",
        "GUIDES": "Guides",
        "PAGES": "Pages",
        "SUPPORTERS": "Supporters",
        "SLIDERS": "Sliders",
        "TICKETS": "Tickets",
        "MIDDLETILE": "Middle tile",
        "MEDIA": "Media",
        "FORMS": "Forms",
        "RECOMMENDATIONS": "Recommendations",
        "BUSES": "Buses",
        "BUS": "Bus",
        "TRACKERS": "Trackers",
        "ROUTES": "Routes",
        "STATIONS": "Stations",
        "TRACKERMAP": "Map",
        "TIMETABLE": "Schedule",
        "NOTIFICATIONS": "Push",
        "PROGRAMCATEGORIES": "Programcategories",
        "GALLERY": "Gallery",
        "GALLERIES": "Galleries",
        "CONTACTPEOPLE": "Contact people",
        "QUESTIONS": "Questions",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/menu.js